<template>
    <div>
        <div class="select__control select__control--single" ref="control" :class="selectClass">
            <div class="select__control-body" @click.prevent.stop="onShowList">
                <div class="flex-grow-1 d-flex flex-wrap mr-2" v-if="selectedObject[labelKey]">
                    {{ selectedObject[labelKey] }}
                </div>
                <div class="flex-grow-1 d-flex flex-wrap" v-else-if="placeholder && showPlaceholder">
                    <span class="text-secondary">{{ placeholder }}</span>
                </div>
                <div class="flex-grow-1 d-flex flex-wrap" v-else></div>
                <div class="select__control--dropdown-button flex-grow-0 d-flex align-items-center">
                    <b-button class="select__dropdown-button mr-2" v-if="clearable" @click="onClear"><b-icon icon="x" /></b-button>
                    <b-button class="select__dropdown-button" @click="onShowList"><b-icon icon="chevron-down" /></b-button>
                </div>
            </div>

            <div class="select__dropdown" ref="dropdown" v-show="dropdownVisible" v-click-outside="hideDropdown">
                <div class="select__dropdown-title">
                    <div v-if="label" :class="{'mb-3': hasSearch}"><strong>{{ label }}</strong></div>
                    <div class="select__dropdown--search mb-2" v-if="hasSearch">
                        <input type="text" @input="onInitSearch" :placeholder="searchPlaceholder" class="mr-1">
                        <b-icon icon="search" class="text-secondary"/>
                    </div>
                </div>
                <div class="select__dropdown-body">
                    <div class="select__dropdown-options" v-if="!loading && options.length">
                        <div v-for="(option, i) in options" class="select__dropdown-item d-flex align-items-center"
                             :class="{ 'selected': isOptionSelected(option) }" @click="onItemClick(option)">
                            <span class="flex-grow-1">{{ option.text }}</span>
                            <b-icon icon="check" size="lg" v-if="isOptionSelected(option)"/>
                        </div>
                    </div>
                    <div class="select__dropdown-loading" v-else-if="loading">
                        <b-spinner variant="info"></b-spinner>
                    </div>
                    <div class="select__dropdown-loading" v-else>
                        <span v-if="!loadingError">Результаты не найдены</span>
                        <span v-else class="text-danger">Ошибка загрузки</span>
                    </div>
                </div>
                <div class="select__dropdown-pagination" v-show="pagesCount > 1 && !loading">
                    <b-button class="select__dropdown-button p-3" @click="onChangePage(-1)" :disabled="page === 1">
                        <b-icon v-if="page !== 1" icon="chevron-left" variant="info"/>
                        <b-icon v-else icon="chevron-left" variant="secondary"/>
                    </b-button>
                    <b-button class="select__dropdown-button p-3" @click="onChangePage(1)" :disabled="page === pagesCount">
                        <b-icon v-if="page !== pagesCount" icon="chevron-right" variant="info"/>
                        <b-icon v-else icon="chevron-right" variant="secondary"/>
                    </b-button>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import {SelectMixin} from "@/components/Select/selectMixin";

export default {
    name: "SingleSelect",
    mixins: [ SelectMixin ],
    props: {
        selectedObject: { type: Object, default: () => { return {} } },  // модель
        placeholder: { type: String, default: "Выберите из списка" },
        clearable: { type: Boolean, default: false },
        noBorder: Boolean
    },
    model: {
        prop: 'selectedObject',
        event: 'selected-object-changed'
    },
    computed: {
        modelValue: {
            get: function () {
                return this.selectedObject
            },
            set: function (value) {
                this.$emit('selected-object-changed', value)
            }
        },
        selectClass() {
            return `${this.state} ${this.noBorder ? 'no-border': ''}`
        }
    },
    methods: {
        isOptionSelected(option) {
            return option[this.idKey] === this.selectedObject[this.idKey]
        },
        onItemClick(item) {
            const itemData = this.optionData.find(x => x[this.idKey] === item[this.idKey])
            if (this.isOptionSelected(item) && this.clearable) {
                this.modelValue = {};
                this.$emit('select-cleared', this.name)
            } else {
                this.modelValue = itemData;
                this.$emit('select-changed', this.name, itemData)
            }
            this.hideDropdown();
        },
        itemSelect(item) {
            const itemData = this.optionData.find(x => x[this.idKey] === item[this.idKey])
            if (this.isOptionSelected(item) && this.clearable) {
                this.modelValue = {};
                this.$emit('select-cleared', this.name)
            } else {
                this.modelValue = itemData;
                this.$emit('select-set', this.name, itemData)
            }
            this.hideDropdown();
        },
        onInitSearch(e) {
            this.$emit('select-search-init', this.name)
            this.onSearch(e)
        },
        onClear() {
            this.modelValue = {};
            this.$emit('select-cleared', this.name)
        },
    }
}
</script>

<style scoped>

</style>